export const RECRUITING_BUCKET_OPTIONS = [
  { value: 'default', label: 'Normal' },
  { value: 'archived', label: 'Archived' },
];

export const RETENTION_BUCKET_OPTIONS = [
  ...RECRUITING_BUCKET_OPTIONS,
  { value: 'recruiting', label: 'Recruiting' },
];

export const CANDIDATE_BUCKET_OPTIONS = [
  { value: 'archived', label: 'Archived' },
];
